import { gql } from '@apollo/client';

const ADD_CUSTOMER = gql`
    mutation AddUser($input: AddUser!) {
        addUser(input: $input) {
            data {
                application_type
                cognito_id
                createdAt
                device_arn
                email
                first_name
                id
                last_logged_at
                last_name
                phone_number
                profile_image
                role_id
                status
                updatedAt
                user_addresses {
                    address_type
                    city
                    country
                    createdAt
                    id
                    state
                    street
                    updatedAt
                    user_id
                    zip_code
                }
            }
            message
            success
        }
    }
`;

export { ADD_CUSTOMER };
